export default __webpack_public_path__ + "static/media/like.ca329a2b.png";